module.exports = __webpack_public_path__ + "img/museu-arte2.5f3c29dd.jpeg";